function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon/outlinedapplication/search",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "9ux2rxry7a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlinedapplication/search (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h22v22H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlinedapplication/search (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlinedapplication/search",
    style: {
      clipPath: "url(#9ux2rxry7a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlinedapplication/search (clip group)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlinedapplication/search (style)",
    style: {
      fill: "none"
    },
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.075 17.187a.175.175 0 0 1-.067-.014.164.164 0 0 1-.058-.038l-5.579-5.577A6.446 6.446 0 0 1 1.888 11 6.445 6.445 0 1 1 11 1.888a6.444 6.444 0 0 1 .554 8.484l5.58 5.58a.16.16 0 0 1 .038.057.175.175 0 0 1 0 .135.172.172 0 0 1-.038.058l-.937.934a.17.17 0 0 1-.057.038.177.177 0 0 1-.065.013zM6.445 1.633a4.812 4.812 0 1 0 3.4 1.409 4.787 4.787 0 0 0-3.4-1.409z",
    transform: "translate(2.406 2.406)",
    style: {
      fill: "#7b7b7b"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetail);
export default __webpack_public_path__ + "static/media/detail.a7d52f7329bcb20899359f3a6b522e9b.svg";
export { ForwardRef as ReactComponent };